export default class ResponsiveHelper {
    public static device = {
        isTouch: "ontouchstart" in window,
        isSmartphone: function () { return window.matchMedia("screen and (max-width:599px)").matches; },
        isSmalltablet: function () { return window.matchMedia("screen and (min-width:600px) and (max-width:749px)").matches; },
        isTablet: function () { return window.matchMedia("screen and (min-width:750px) and (max-width:1023px)").matches; },
        isDesktop: function () { return window.matchMedia("screen and (min-width:1024px)").matches; },
        isRetina: function () { return window.matchMedia("only screen and (-webkit-min-device-pixel-ratio: 2), only screen and (min--moz-device-pixel-ratio: 2), only screen and (-o-min-device-pixel-ratio: 2/1), only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx)").matches; },
        OS: {
            isAndroid: function () {
                return navigator.userAgent.indexOf("Edge") < 0 && navigator.userAgent.match(/Android/i) ? true : false;
            },
            isIOS: function () {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            isWindows: function () {
                return navigator.userAgent.indexOf("Edge") >= 0 || navigator.userAgent.match(/IEMobile/i) ? true : false;
            },
            isAny: function () {
                return this.isMobile.Android() || this.isMobile.iOS() || this.isMobile.Windows();
            }
        }
    };

    public static onResize() {
        this.retinaImages();
    }

    private static retinaImages() {
        if (this.device.isRetina()) {
            $("img.retina").attr("src", function () {
                return $(this).attr("src").replace(/(\.[\w\d_-]+)$/i, "@2x$1");
            });
        }
    }
}